/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type ReplacePlaceholderInput = {|
  placeholderId?: ?string,
  personId?: ?string,
  deletePlaceholder?: ?boolean,
  csrfToken?: ?string,
  socketClientId?: ?string,
  clientMutationId?: ?string,
|};
export type replacePlaceholderMutationVariables = {|
  input: ReplacePlaceholderInput
|};
export type replacePlaceholderMutationResponse = {|
  +replacePlaceholder: ?{|
    +placeholderId: ?string,
    +deletePlaceholder: ?boolean,
    +deletedPlaceholderAllocationIds: ?$ReadOnlyArray<?string>,
    +allocations: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +startYear: ?number,
        +startMonth: ?number,
        +startDay: ?number,
        +endYear: ?number,
        +endMonth: ?number,
        +endDay: ?number,
        +monday: ?number,
        +tuesday: ?number,
        +wednesday: ?number,
        +thursday: ?number,
        +friday: ?number,
        +saturday: ?number,
        +sunday: ?number,
        +description: ?string,
        +isProjectGroupAllocation: ?boolean,
        +projectGroupId: ?string,
        +projectGroupName: ?string,
        +projectGroupCompanyProjectGroupId: ?number,
        +projectGroupColor: ?string,
        +person: ?{|
          +id: string
        |},
        +project: ?{|
          +id: string
        |},
      |}
    |}>,
  |}
|};
export type replacePlaceholderMutation = {|
  variables: replacePlaceholderMutationVariables,
  response: replacePlaceholderMutationResponse,
|};
*/


/*
mutation replacePlaceholderMutation(
  $input: ReplacePlaceholderInput!
) {
  replacePlaceholder(input: $input) {
    placeholderId
    deletePlaceholder
    deletedPlaceholderAllocationIds
    allocations {
      node {
        id
        startYear
        startMonth
        startDay
        endYear
        endMonth
        endDay
        monday
        tuesday
        wednesday
        thursday
        friday
        saturday
        sunday
        description
        isProjectGroupAllocation
        projectGroupId
        projectGroupName
        projectGroupCompanyProjectGroupId
        projectGroupColor
        person {
          id
        }
        project {
          id
        }
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "ReplacePlaceholderInput!"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  (v1/*: any*/)
],
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ReplacePlaceholderPayload",
    "kind": "LinkedField",
    "name": "replacePlaceholder",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "placeholderId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletePlaceholder",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedPlaceholderAllocationIds",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AllocationTypeEdge",
        "kind": "LinkedField",
        "name": "allocations",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Allocation",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startYear",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startMonth",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startDay",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endYear",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endMonth",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endDay",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "monday",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "tuesday",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "wednesday",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "thursday",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "friday",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "saturday",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sunday",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "description",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isProjectGroupAllocation",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectGroupId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectGroupName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectGroupCompanyProjectGroupId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectGroupColor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Person",
                "kind": "LinkedField",
                "name": "person",
                "plural": false,
                "selections": (v2/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ProjectType",
                "kind": "LinkedField",
                "name": "project",
                "plural": false,
                "selections": (v2/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "replacePlaceholderMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "replacePlaceholderMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "replacePlaceholderMutation",
    "operationKind": "mutation",
    "text": "mutation replacePlaceholderMutation(\n  $input: ReplacePlaceholderInput!\n) {\n  replacePlaceholder(input: $input) {\n    placeholderId\n    deletePlaceholder\n    deletedPlaceholderAllocationIds\n    allocations {\n      node {\n        id\n        startYear\n        startMonth\n        startDay\n        endYear\n        endMonth\n        endDay\n        monday\n        tuesday\n        wednesday\n        thursday\n        friday\n        saturday\n        sunday\n        description\n        isProjectGroupAllocation\n        projectGroupId\n        projectGroupName\n        projectGroupCompanyProjectGroupId\n        projectGroupColor\n        person {\n          id\n        }\n        project {\n          id\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'b5b92668ca9d76c3e90967efc4bea7bd';

module.exports = node;
